import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Users, ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import { useAuth } from "@/context/AuthContext";

export default function Chapters() {
  const { user } = useAuth();
  const [chapters, setChapters] = useState([]);

  useEffect(() => {
    api.get("/chapters").then(r => setChapters(r.data)).catch(() => {});
  }, []);

  const role = user?.role === "admin" ? "admin" : "member";

  return (
    <DashboardShell role={role} title="Our Chapters" subtitle="Starting in Hyderabad. Expanding city by city.">
      <div data-testid="chapters-page">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <p className="overline">Our Chapters</p>
            <h1 className="font-display text-4xl md:text-5xl text-aubergine mt-4 leading-tight">
              Starting in <em className="text-rose not-italic">Hyderabad.</em> Expanding city by city.
            </h1>
          </div>
          <div className="lg:col-span-4 text-plumSoft font-light">
            Founding cohort priority access reserved for members from cities where chapters are still opening.
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {chapters.map(c => {
            const isLive = !((c.founded || "").startsWith("Coming"));
            return (
              <Link key={c.id} to={`/chapters/${c.id}`} data-testid={`chapter-card-${c.id}`} className="card-luxe overflow-hidden group block">
                <div className="aspect-[16/10] overflow-hidden relative">
                  <img src={c.cover_image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-aubergine/80 via-aubergine/20 to-transparent" />
                  <div className="absolute top-4 left-4">
                    {isLive ? (
                      <span className="inline-flex items-center gap-1.5 bg-rose px-3 py-1 rounded-full text-[10px] tracking-widest uppercase text-ivory font-medium">
                        <span className="w-1.5 h-1.5 rounded-full bg-ivory animate-pulse" /> Live
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 bg-ivory/90 px-3 py-1 rounded-full text-[10px] tracking-widest uppercase text-aubergine">
                        <Sparkles className="w-3 h-3" /> {c.founded}
                      </span>
                    )}
                  </div>
                  <div className="absolute bottom-4 left-4 right-4 text-ivory">
                    <h3 className="font-display text-3xl leading-tight">{c.name}</h3>
                    <p className="text-xs text-ivory/70 mt-1 flex items-center gap-2"><MapPin className="w-3 h-3" />{c.city}</p>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-sm text-plumSoft font-light line-clamp-2">{c.description}</p>
                  <div className="mt-5 flex items-center justify-between text-xs text-plum">
                    <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />{c.members_count || 0} members</span>
                    <span className="flex items-center gap-1 link-underline">Explore <ArrowRight className="w-3 h-3" /></span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </DashboardShell>
  );
}
